import type { PartialVerseData } from "@rsc/scripture-model";

export interface PartialVerse {
  label: string;
  fromOrdinal: number;
  toOrdinal: number;
}
/**
 * Create a labelled partial verse with inclusive, zero-based word ordinal bounds.
 */
export function makeVersePart(
  label: string,
  fromOrdinal: number,
  toOrdinal: number,
): PartialVerse {
  return { label, fromOrdinal, toOrdinal };
}
/**
 * Map presentation word bounds to API field names in a fresh partial-verse DTO.
 */
export function dumpVersePart(part: PartialVerse): PartialVerseData {
  return {
    label: part.label,
    fromWordOrdinal: part.fromOrdinal,
    toWordOrdinal: part.toOrdinal,
  };
}
/**
 * Map API word bounds to a fresh plain partial-verse presentation record.
 */
export function createPartialVerse(data: PartialVerseData): PartialVerse {
  return makeVersePart(data.label, data.fromWordOrdinal, data.toWordOrdinal);
}
